import { Pizza } from "../models/pagination";

export const cardList: Array<Pizza> = [
    {
        name: "Hawaiana",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Hawaiana.png",
        description: "Mozarella, jamón y pilña caramelizada en trocitos",
        prices: [
            {
                size: 'P',
                value: 18900
            },
            {
                size: 'S',
                value: 24900
            },
            {
                size: 'M',
                value: 36700
            },
            {
                size: 'L',
                value: 51700
            }
        ]
    },
    {
        name: "Hawaiana Pollo",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Hawaiana-Pollo.png",
        description: "Mozzarella, jamón, pollo y piña caramelizada en trocitos",
        prices: [
            {
                size: 'P',
                value: 21800
            },
            {
                size: 'S',
                value: 31300
            },
            {
                size: 'M',
                value: 42400
            },
            {
                size: 'L',
                value: 60200
            }
        ]
    },
    {
        name: "Hawaiana Pollo BBQ",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Hawaiana-Pollo-BBQ.png",
        description: "Base de salsa BBQ, pollo, tocineta y piña caramelizada",
        prices: [
            {
                size: 'P',
                value: 28500
            },
            {
                size: 'S',
                value: 39900
            },
            {
                size: 'M',
                value: 49900
            },
            {
                size: 'L',
                value: 71500
            }
        ]
    },
    {
        name: "Holandesa",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Holandesa.png",
        description: "Pollo, piña, queso holandés y parmesano",
        prices: [
            {
                size: 'P',
                value: 23700
            },
            {
                size: 'S',
                value: 32100
            },
            {
                size: 'M',
                value: 45200
            },
            {
                size: 'L',
                value: 66100
            }
        ]
    },
    {
        name: "Maduritos",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Maduritos.png",
        description: "Bocadillo, maduritos, tocineta, queso holandés y queso parmesano.",
        prices: [
            {
                size: 'P',
                value: 23700
            },
            {
                size: 'S',
                value: 32100
            },
            {
                size: 'M',
                value: 45200
            },
            {
                size: 'L',
                value: 66100
            }
        ]
    },
    {
        name: "Super Especial",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/super-especial.png",
        description: "Salami, jamón, pollo, pepperoni americano, chorizo español y albahaca seca",
        prices: [
            {
                size: 'P',
                value: 17200
            },
            {
                size: 'S',
                value: 22600
            },
            {
                size: 'M',
                value: 36200
            },
            {
                size: 'L',
                value: 48100
            }
        ]
    },
    {
        name: "Pepperoni Americano",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/pepperoni-Americano.png",
        description: "Mozzarela y pepperoni americano",
        prices: [
            {
                size: 'P',
                value: 19300
            },
            {
                size: 'S',
                value: 25800
            },
            {
                size: 'M',
                value: 37900
            },
            {
                size: 'L',
                value: 49600
            }
        ]
    },
    {
        name: "Queso Salami",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/salami.png",
        description: "Mozzarella y Salami",
        prices: [
            {
                size: 'P',
                value: 17200
            },
            {
                size: 'S',
                value: 22600
            },
            {
                size: 'M',
                value: 36200
            },
            {
                size: 'L',
                value: 48100
            }
        ]
    },
    {
        name: "3 Carnes",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/3-Carnes.png",
        description: "Pollo, chorizo de res, pepperoni americano y albahaca seca",
        prices: [
            {
                size: 'P',
                value: 23700
            },
            {
                size: 'S',
                value: 32100
            },
            {
                size: 'M',
                value: 45200
            },
            {
                size: 'L',
                value: 66100
            }
        ]
    },
    {
        name: "5 Carnes",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/5-carnes.png",
        description: "Salami, jamón, pollo, cábano y tocineta",
        prices: [
            {
                size: 'P',
                value: 24800
            },
            {
                size: 'S',
                value: 36200
            },
            {
                size: 'M',
                value: 47800
            },
            {
                size: 'L',
                value: 66800
            }
        ]
    },
    {
        name: "Pollo Jamón",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Pollo-Jamon.png",
        description: "Pizza Pollo Jamón",
        prices: [
            {
                size: 'P',
                value: 23700
            },
            {
                size: 'S',
                value: 32100
            },
            {
                size: 'M',
                value: 45200
            },
            {
                size: 'L',
                value: 66100
            }
        ]
    },
    {
        name: "Pollo Champiñones",
        image: "https://www.salvators.com.co/wp-content/uploads/2020/09/Pollo-Champin%CC%83ones.png",
        description: "Mozzarella",
        prices: [
            {
                size: 'P',
                value: 21800
            },
            {
                size: 'S',
                value: 31300
            },
            {
                size: 'M',
                value: 42400
            },
            {
                size: 'L',
                value: 60200
            }
        ]
    }
];